// file rename
class Api {
  constructor(options) {
    this.baseURL = options.baseURL;
    this.headers = { ...options.headers };
  }

  // Helper method to handle responses
  async handleResponse(response) {
    if (response.ok) {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        return response.json();
      }
      return response;
    }

    try {
      const error = await response.json();
      throw new Error(error.message || `Error: ${response.status}`);
    } catch (error) {
      throw new Error(`Error: ${response.status}`);
    }
  }

  // Helper method for fetch requests
  async fetchRequest(endpoint, options = {}) {
    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, {
        ...options,
        headers: this.headers,
      });
      return this.handleResponse(response);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  // ============ AUTHENTICATION ============

  // Register a new user
  registerUser(fullName, email, password) {
    console.log(fullName, email, password);
    return this.fetchRequest("/register", {
      method: "POST",
      body: JSON.stringify({
        fullName: fullName,
        email: email,
        password: password,
        role: "student",
      }),
    });
  }

  // Login user
  loginUser(email, password) {
    return this.fetchRequest("/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  }

  async getUserInfo() {
    this.initToken();
    try {
      const response = await fetch(this.baseURL + "/users/me", {
        headers: this.headers,
      });
      if (response.ok) {
        const data = await response.json();
        console.log("User info loaded:", {
          fullName: data.fullName,
          role: data.role,
        });
        return data;
      }
      throw new Error(`Error: ${response.status}`);
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async updateUserInfo(userData) {
    return this.fetchRequest("/users/me", {
      method: "PATCH",
      body: JSON.stringify(userData),
    });
  }

  tokenCheck(jwt) {
    return fetch(this.baseURL + "/users/me", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: jwt,
      },
    }).then((res) => {
      if (res.ok) {
        return res.json();
      }
      return Promise.reject(res);
    });
  }

  // ============ PHONETIC TEST ============

  // Get or create test result for current user
  // Get or create test result for current user
  async getPhoneticTestResult() {
    this.initToken();
    return this.fetchRequest("/phonetic-test/result", {
      method: "GET",
    });
  }

  // Get test history
  async getPhoneticTestHistory(limit = 10) {
    this.initToken();
    return this.fetchRequest(`/phonetic-test/history?limit=${limit}`, {
      method: "GET",
    });
  }

  // Get specific attempt details
  async getPhoneticTestAttempt(attemptId) {
    this.initToken();
    return this.fetchRequest(`/phonetic-test/attempt/${attemptId}`, {
      method: "GET",
    });
  }

  // Save test answers (auto-save)
  async savePhoneticTestAnswers(answers, variant) {
    this.initToken();
    return this.fetchRequest("/phonetic-test/save", {
      method: "POST",
      body: JSON.stringify({ answers, variant }),
    });
  }

  // Submit completed test
  async submitPhoneticTest(answers, variant, score, totalQuestions, questions) {
    this.initToken();
    return this.fetchRequest("/phonetic-test/submit", {
      method: "POST",
      body: JSON.stringify({
        answers,
        variant,
        score,
        totalQuestions,
        questions, // Add questions to the request
      }),
    });
  }

  // Reset current test
  async resetPhoneticTest() {
    this.initToken();
    return this.fetchRequest("/phonetic-test/reset", {
      method: "POST",
    });
  }

  // ============ TOKEN MANAGEMENT ============

  setHeaders(jwt) {
    this.headers.authorization = jwt;
  }

  // Set token and store it
  setToken(token) {
    this.headers.authorization = token;
    localStorage.setItem("token", token);
  }

  // ============ TEACHER ENDPOINTS ============

  // Get all students test results (teacher only)
  async getAllStudentsResults(limit = 50, offset = 0) {
    this.initToken(); // Ensure token is set
    console.log(
      "Making request with token:",
      this.headers.authorization ? "Present" : "Missing",
    );
    return this.fetchRequest(
      `/teacher/results?limit=${limit}&offset=${offset}`,
      {
        method: "GET",
      },
    );
  }

  // Get specific student's test history (teacher only)
  async getStudentTestHistory(studentId, limit = 20) {
    this.initToken();
    return this.fetchRequest(
      `/teacher/student/${studentId}/history?limit=${limit}`,
      {
        method: "GET",
      },
    );
  }

  // Get specific student's attempt details (teacher only)
  async getStudentAttemptDetails(studentId, attemptId) {
    this.initToken();
    return this.fetchRequest(
      `/teacher/student/${studentId}/attempt/${attemptId}`,
      {
        method: "GET",
      },
    );
  }

  // Get test statistics (teacher only)
  async getTestStatistics() {
    this.initToken();
    return this.fetchRequest("/teacher/statistics", {
      method: "GET",
    });
  }

  // ============ STUDENT ENDPOINTS ============

  // Get current student's test history
  async getMyTestHistory(limit = 20) {
    this.initToken();
    return this.fetchRequest(`/phonetic-test/my-history?limit=${limit}`, {
      method: "GET",
    });
  }

  // Get current student's attempt details
  async getMyAttemptDetails(attemptId) {
    this.initToken();
    return this.fetchRequest(`/phonetic-test/my-attempt/${attemptId}`, {
      method: "GET",
    });
  }

  // Get current student's statistics
  async getMyStatistics() {
    this.initToken();
    return this.fetchRequest("/phonetic-test/my-statistics", {
      method: "GET",
    });
  }

  // Initialize token from localStorage
  initToken() {
    const token = localStorage.getItem("token");
    if (token) {
      this.headers.authorization = token;
      console.log("this.headers.authorization: " + this.headers.authorization);
    }
  }
}

// Configuration with your backend URL
const options = {
  baseURL: "https://api.hosfatantabolis.ru", // Change to your backend URL
  headers: {
    "Content-Type": "application/json",
    authorization: "",
  },
};

const api = new Api(options);
export default api;
